<!-- Start Breadcrumbs -->
<app-breadcrumbs title="List View" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->
<div class="row g-4 mb-4">
    <div class="col-sm">
        <div>
            <a href="javascript:void(0);" class="btn btn-success"><i class="ri-add-line align-bottom me-1"></i> Add
                Candidate</a>
        </div>
    </div>
    <div class="col-sm-auto">
        <div class="d-md-flex justify-content-sm-end gap-2">
            <div class="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0">
                <input type="text" class="form-control" id="searchJob" autocomplete="off" placeholder="Search for candidate name or designation..." [(ngModel)]="searchTerm" (ngModelChange)="performSearch()">
                <i class="ri-search-line search-icon"></i>
            </div>

            <select class="form-control w-md choices__inner" data-choices data-choices-search-false>
                <option value="All">All</option>
                <option value="Today">Today</option>
                <option value="Yesterday" selected>Yesterday</option>
                <option value="Last 7 Days">Last 7 Days</option>
                <option value="Last 30 Days">Last 30 Days</option>
                <option value="This Month">This Month</option>
                <option value="Last Year">Last Year</option>
            </select>
        </div>
    </div>
</div>
<div class="row gy-2 mb-2" id="candidate-list">
    @for ( list of listview; track $index) {
    <div class="col-md-6 col-lg-12">
        <div class="card mb-0">
            <div class="card-body">
                <div class="d-lg-flex align-items-center">
                    <div class="flex-shrink-0">
                        <div class="avatar-sm rounded"><img src="{{list.img}}" alt="" class="member-img img-fluid d-block rounded"></div>
                    </div>
                    <div class="ms-lg-3 my-3 my-lg-0"> <a routerLink="/pages/profile">
                            <h5 class="fs-16 mb-2">{{list.name}}</h5>
                        </a>
                        <p class="text-muted mb-0">{{list.designation}}</p>
                    </div>
                    <div class="d-flex gap-4 mt-0 text-muted mx-auto">
                        <div><i class="ri-map-pin-2-line text-primary me-1 align-bottom float-start"></i>
                            {{list.location}}</div>
                        <div><i class="ri-time-line text-primary me-1 align-bottom"></i>
                            <span class="badge" [ngClass]="{'bg-danger-subtle text-danger': list.type == 'Part Time' ,
                            'bg-success-subtle text-success': list.type == 'Full Time',
                            'bg-secondary-subtle text-secondary': list.type == 'Freelancer' }">{{list.type}}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap gap-2 align-items-center mx-auto my-3 my-lg-0">
                        <div class="badge text-bg-success"> <i class="mdi mdi-star me-1"></i>{{list.rating}} </div>
                        <div class="text-muted">{{list.ratingCount}} Ratings</div>
                    </div>
                    <div class="d-flex gap-1 mt-0 ">
                        <a href="javascript:void(0);" class="btn btn-soft-success">View Details</a> <a href="javascript:void(0);" class="btn btn-ghost-danger btn-icon custom-toggle active" data-bs-toggle="button">
                            <span class="icon-off" (click)="bookmarklist($index)">
                                <i [ngClass]="(list.bookmark == true)?'ri-bookmark-3-fill align-bottom':'ri-bookmark-line align-bottom'"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    <!-- pagination -->
    <ngb-pagination class="d-flex justify-content-end pt-2" [collectionSize]="alllistview?.length" [(page)]="service.page" [pageSize]="service.pageSize" (pageChange)="changePage()" aria-label="Custom pagination">
        <ng-template ngbPaginationPrevious let-page let-pages="pages">
            <i class="ci-arrow-left me-2"></i>
            Prev
        </ng-template>
        <ng-template ngbPaginationNext>
            Next
            <i class="ci-arrow-right ms-2"></i>
        </ng-template>
    </ngb-pagination>

    <div id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>